import React from "react";
import { Modal, Form } from "react-bootstrap";
import crossImage from "../../../src/public/images/close.svg";
import styles from "./beneficiary.module.css";
import Button from "../../Common/Button";

function CommissionConfigModal({
  isOpen,
  onRequestClose,
  onSubmit,
  statusLoading = false,
  submitLoading = false,
  isActive = false,
  onToggle,
  beneficiaryName = "",
  showSuccess = false,
  successMessage = "Transfer fee configuration updated successfully.",
  errorMessage = "",
}) {
  return (
    <Modal
      show={isOpen}
      onHide={onRequestClose}
      className={`${styles.modalRight}`}
      centered
    >
      <Modal.Header>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeading}>Transfer Fee Config</div>
          <div id="crossImage">
            <img src={crossImage} alt="" onClick={() => onRequestClose()} />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body id="modal-body">
        <div>
          {beneficiaryName && (
            <>
                <div className={styles.modalBody}>
                Transfer fee status for <strong>{beneficiaryName}</strong>
                </div>

                <div className={styles.transferFeeInfo}>
                <p>
                    <strong>Active:</strong> When transfer fee status is active , 
                    transfers made to the beneficiary will incur zero fee.
                </p>
                <p>
                    <strong>Inactive:</strong> When transfer fee status is inactive, 
                    the transfers will be charged as per the rate displayed.
                </p>
                </div>
            </>
            )}
          

          {statusLoading ? (
            <div className={styles.toggleRow}>Loading status...</div>
          ) : (
            <div className={styles.toggleRow}>
              <span>Inactive</span>
              <Form.Check
                type="switch"
                id="commission-status-switch"
                checked={isActive}
                onChange={(e) => onToggle(e.target.checked)}
                disabled={submitLoading}
              />
              <span>Active</span>
            </div>
          )}

          {errorMessage && (
            <div className={styles.modalError}>{errorMessage}</div>
          )}

          {showSuccess && (
            <div className={styles.modalSuccess}>{successMessage}</div>
          )}

          <div className={styles.modalButton}>
            <Button
              onClick={onRequestClose}
              title={"Cancel"}
              disabled={submitLoading}
            />
            <Button
              onClick={onSubmit}
              title={"Submit"}
              loading={submitLoading}
              disabled={submitLoading || statusLoading}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default CommissionConfigModal;
